import { getBillingCutoffAt, isCreatedBeforeCutoff } from "@reactive-resume/utils";
import { useMemo } from "react";

import { useResumes } from "@/client/services/resume";
import { useUser } from "@/client/services/user";

export function useGrandfatherAccess() {
  const { user } = useUser();
  const { resumes } = useResumes();

  const cutoff = useMemo(
    () => getBillingCutoffAt(import.meta.env.VITE_BILLING_CUTOFF_AT),
    [],
  );

  const hasLegacyResume = useMemo(
    () => (resumes ?? []).some((resume) => isCreatedBeforeCutoff(resume.createdAt, cutoff)),
    [resumes, cutoff],
  );

  const isGrandfathered = Boolean(user && !user.planTier && hasLegacyResume);

  const canExportCreatedAt = (createdAt: Date | string) =>
    Boolean(user?.planTier) || isCreatedBeforeCutoff(createdAt, cutoff);

  return { cutoff, hasLegacyResume, isGrandfathered, canExportCreatedAt };
}
